import rides from "./rides.component";
import ridesUrls from "./rides.urls";
import RidesTransforms from "./rides.transforms";

const ridesModule = angular
  .module("app.components.rides", [])
  .component("ridesPage", rides)
  .service("RidesTransforms", RidesTransforms)
  .config(ridesUrls);

export default ridesModule;



// WEBPACK FOOTER //
// ./src/pages/rides/rides.module.js